import { Form, Radio } from "antd";
import { useMemo } from "react";
import { IOption } from "../../../../types/Option";

type VisibilityFormItemProps = {
  name?: string[];
};

export const VisibilityFormItem = ({ name }: VisibilityFormItemProps) => {
  const visibilityOptions: IOption[] = useMemo(
    () => [
      { label: "Not visible", value: 0 },
      { label: "Primary Seller", value: 1 },
      { label: "Primary Buyer", value: 2 },
      { label: "Primary Seller & Primary Buyer", value: 3 },
    ],
    [],
  );

  return (
    <Form.Item
      label="Portal Visibility"
      name={name || "visibility"}
      className="mb-6 w-100"
    >
      <Radio.Group
        options={visibilityOptions}
        className="d-flex flex-column visibility-options"
      />
    </Form.Item>
  );
};
